module.exports = __webpack_public_path__ + "b89efd3b3f222aee0590625ec11b5816.svg";